exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2s5KQ78cNDaxAAGL7B5--S{position:absolute;z-index:1;right:0;bottom:0;left:0;background:#fff;box-shadow:0 0 15px rgba(0,0,0,0.15);min-width:100px;transition:height 200ms ease}._2s5KQ78cNDaxAAGL7B5--S .kLlFwyJSI-GPWXECzPqE4{padding:0 0;height:100%;display:flex;flex-direction:column}\n", ""]);

// Exports
exports.locals = {
	"sgFloat": "_2s5KQ78cNDaxAAGL7B5--S",
	"wrap": "kLlFwyJSI-GPWXECzPqE4"
};